var _a;
import { appointmentStatus } from './ehrNoteEnums';
export var appointmentStatuses = (_a = {},
    _a[appointmentStatus.completed] = 'Client attended',
    _a[appointmentStatus.notAttended] = 'Client did not attend',
    _a[appointmentStatus.lateCancel] = 'Client canceled late <24h',
    _a);
export var AppointmentStatusesAsOptions = Object.entries(appointmentStatuses).map(function (_a) {
    var k = _a[0], v = _a[1];
    return ({
        value: k,
        label: v,
    });
});
